import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cumulativeTime',
  pure: true,
  standalone: false
})
export class CumulativeTimePipe implements PipeTransform {
  transform(milliseconds: number | null | undefined): string {
    if (!milliseconds) return '0h 0m';

    const totalSeconds = Math.floor(milliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    if (totalHours < 24) {
      const hours = totalHours;
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}m`;
    } else {
      const days = totalDays;
      const hours = totalHours % 24;
      return `${days}d ${hours}h`;
    }
  }
}
